import script from "./device-set.vue?vue&type=script&setup=true&lang=js"
export * from "./device-set.vue?vue&type=script&setup=true&lang=js"

import "./device-set.vue?vue&type=style&index=0&id=77a0a6c8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77a0a6c8"]])

export default __exports__